import { useTheme } from 'styled-components';
import {
  Col,
  ENotificationType,
  TRtkErrorType,
  useShowToastNotification,
  useTranslation,
} from '@packages/utils';
import { EIconNames, Icon } from 'components/Base/Icon';
import { useDeleteElcMeetingTopicMutation } from 'redux/apiSlice/elcs.slice';
import { TRemoveTopicProps } from './RemoveTopic.types';

const RemoveTopic = ({ elcId, meetingId, topicId }: TRemoveTopicProps) => {
  const { t } = useTranslation({
    keyPrefix:
      'descriptions.admin-portal.elcs.detail.meetings-tab.details.topics.delete',
  });
  const theme = useTheme();
  const { showToastNotification } = useShowToastNotification();
  const [deleteTopic, { isLoading }] = useDeleteElcMeetingTopicMutation();

  const handleSubmit = async (e: {
    stopPropagation: () => void;
    preventDefault: () => void;
  }) => {
    e.stopPropagation();
    if (isLoading) {
      e.preventDefault();
      return;
    }
    try {
      const payload: any = {
        meetingId,
        topicId,
      };

      if (elcId) {
        payload.elcId = elcId;
      }

      await deleteTopic(payload).unwrap();
      showToastNotification({
        message: t('SUCCESS_MESSAGE'),
        type: ENotificationType.SUCCESS,
      });
    } catch (err) {
      showToastNotification({
        message: (err as TRtkErrorType)?.data?.message,
        type: ENotificationType.ERROR,
      });
    }
  };

  return (
    <Col onClick={handleSubmit}>
      <Icon
        icon={EIconNames.DELETE_OUTLINED}
        color={theme.colorBlackIconColor}
        className="pointer"
        tooltip={t('DELETE_TOOLTIP')}
      />
    </Col>
  );
};

export default RemoveTopic;
